// extracted by mini-css-extract-plugin
export default {"msg_container":"fea","message":"gea","show":"hea","fromRD":"iea","fromCustomer":"jea","note":"kea","loading":"lea","image":"mea","initials":"nea","input_wrapper":"oea","input":"pea"};
    if(module.hot) {
      // 1737143665360
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  